<template>
	<div class="app-container">
		<el-card class="filter-card" shadow="hover">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAddCustomer">
						<el-icon>
							<Plus />
						</el-icon> 新建客户审核
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filterForm.name" style="width: 260px" clearable placeholder="请输入客户名称"
						@clear="handleQuery">
						<template #prepend>客户名称</template>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filterForm.status" placeholder="审核状态" clearable style="width: 150px">
						<el-option label="待审核" :value="0"></el-option>
						<el-option label="已通过" :value="1"></el-option>
						<el-option label="已拒绝" :value="2"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card class="table-card" shadow="hover">
			<el-table :data="approvalList" height="calc(100vh - 320px)" style="width: 100%" stripe v-loading="loading">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="customerName" label="客户名称" min-width="200"></el-table-column>
				<!-- <el-table-column prop="type" label="操作类型" width="100">
					<template #default="scope">
						<el-tag :type="scope.row.type === 'add' ? 'success' : 'warning'">
							{{ scope.row.type === 'add' ? '新增' : '编辑' }}
						</el-tag>
					</template>
				</el-table-column> -->
				<el-table-column prop="status" label="审核状态" width="100">
					<template #default="scope">
						<el-tag :type="getStatusType(scope.row.status)">
							{{ getStatusText(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="username" label="申请人" width="120"></el-table-column>
				<!-- <el-table-column prop="approverName" label="审核人" width="120"></el-table-column> -->
				<el-table-column prop="updateTime" label="申请时间" width="180">
					<template #default="{ row }">
						{{ formatDateTime(row.updateTime) }}
					</template>
				</el-table-column>
				<el-table-column prop="approveTime" label="审核时间" width="180">
					<template #default="{ row }">
						{{ row.approveTime ? formatDateTime(row.approveTime) : '-' }}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
				<el-table-column fixed="right" label="操作" width="300">
					<template #default="scope">
						<el-button size="small" type="info" @click="handleView(scope.row)">查看</el-button>
						<el-button size="small" type="primary" @click="handleApprove(scope.row)"
							v-if="role === 'approval'">审核</el-button>
						<el-button size="small" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
						<!-- <el-button size="small" type="warning" @click="handleCopy(scope.row)">复制</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 客户审核表单对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="60vw"
			:close-on-click-modal="false" align-center>
			<el-form :model="customerForm" :rules="rules" ref="customerForm" label-width="auto">
				<el-form-item label="客户名称" prop="customerName">
					<el-col :span="18">
						<el-input v-model="customerForm.customerName"></el-input>
					</el-col>
				</el-form-item>
				<el-row>
					<el-col :span="14">
						<el-form-item label="所属行业" prop="industry">
							<el-col :span="20">
								<el-input v-model="customerForm.industry"></el-input>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="信用评级(1-5)" prop="creditRating">
							<el-rate v-model="customerForm.creditRating" :texts="['一星', '二星', '三星', '四星', '五星']"
								show-text />
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="客户介绍" prop="intro">
					<el-col :span="20">
						<el-input v-model="customerForm.intro" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<!-- 联系人信息 -->
				<div class="contacts-section">
					<div class="contacts-header">
						<h3>联系人信息</h3>
						<el-button type="primary" @click="addContact">
							<el-icon>
								<Plus />
							</el-icon> 增加联系人
						</el-button>
					</div>
					<div v-for="(contact, index) in customerForm.customerContacts" :key="index" class="contact-item">
						<el-form-item :label="'联系人'+(index + 1)">
							<el-col :span="21"></el-col>
							<el-col :span="3">
								<el-button type="danger" :icon="Search" @click="removeContact(index)"
									v-if="customerForm.customerContacts.length > 1">
									<el-icon>
										<Delete />
									</el-icon>
								</el-button>
							</el-col>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="'姓名'" :prop="'customerContacts.' + index + '.name'"
									:rules="{ required: true, message: '请输入联系人姓名', trigger: 'blur' }">
									<el-input v-model="contact.name"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="'手机号码'" :prop="'customerContacts.' + index + '.mobile'"
									:rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
									<el-input v-model="contact.mobile"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="'电子邮箱'" :prop="'customerContacts.' + index + '.email'">
									<el-input v-model="contact.email"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="'职位'" :prop="'customerContacts.' + index + '.position'">
									<el-input v-model="contact.position"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item :label="'职位介绍'" :prop="'customerContacts.' + index + '.intro'">
							<el-col :span="18">
								<el-input v-model="contact.intro" type="textarea" :rows="2"></el-input>
							</el-col>
						</el-form-item>
					</div>
				</div>

				<!-- 审核信息 -->
				<!-- <el-divider content-position="left">审核信息</el-divider>
				<el-form-item label="申请原因" prop="applyReason">
					<el-col :span="20">
						<el-input v-model="customerForm.applyReason" type="textarea" :rows="3" placeholder="请说明申请原因"></el-input>
					</el-col>
				</el-form-item> -->
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitForm">提交审核</el-button>
				</div>
			</template>
		</el-dialog>

		<!-- 审核对话框 -->
		<el-dialog class="mydialog" title="审核客户" v-model="approveDialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-card shadow="never" style="margin-bottom: 16px;">
				<div class="compare-title">全部变更信息</div>
				<el-table v-if="allChanges && allChanges.length" :data="allChanges" border stripe size="small"
					style="margin-bottom: 10px;">
					<el-table-column prop="object" label="对象/类型" width="140" />
					<el-table-column prop="field" label="字段" width="120" />
					<el-table-column label="变更前" width="200">
						<template #default="scope">
							<span style="color: #909399;">{{ scope.row.before }}</span>
						</template>
					</el-table-column>
					<el-table-column label="变更后" width="200">
						<template #default="scope">
							<span style="color: #409EFF; font-weight: bold;">{{ scope.row.after }}</span>
						</template>
					</el-table-column>
				</el-table>
				<el-empty v-else description="无变更信息" />
			</el-card>
			<el-form :model="approveForm" :rules="approveRules" ref="approveForm" label-width="auto">
				<el-form-item label="审核结果" prop="status">
					<el-radio-group v-model="approveForm.status">
						<el-radio value="1">通过</el-radio>
						<el-radio value="2">拒绝</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item label="审核意见" prop="approveRemark">
					<el-input v-model="approveForm.approveRemark" type="textarea" :rows="4" placeholder="请输入审核意见"></el-input>
				</el-form-item> -->
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="approveDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitApprove">确认审核</el-button>
				</div>
			</template>
		</el-dialog>

		<!-- 查看客户信息对话框 -->
		<el-dialog class="mydialog" title="客户审核详情" v-model="viewDialogVisible" width="60vw"
			:close-on-click-modal="false" align-center>
			<el-card shadow="never">
				<el-descriptions title="客户基本信息" :column="2" border>
					<el-descriptions-item label="客户名称">{{ viewCustomer.customerName }}</el-descriptions-item>
					<el-descriptions-item label="所属行业">{{ viewCustomer.industry }}</el-descriptions-item>
					<el-descriptions-item label="信用评级">
						<el-rate disabled v-model="viewCustomer.creditRating" />
					</el-descriptions-item>
					<!-- <el-descriptions-item label="操作类型">
						<el-tag :type="viewCustomer.type === 'add' ? 'success' : 'warning'">
							{{ viewCustomer.type === 'add' ? '新增' : '编辑' }}
						</el-tag>
					</el-descriptions-item> -->
					<el-descriptions-item label="审核状态">
						<el-tag :type="getStatusType(viewCustomer.status)">
							{{ getStatusText(viewCustomer.status) }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item
						label="申请时间">{{ formatDateTime(viewCustomer.applyTime) }}</el-descriptions-item>
					<el-descriptions-item label="申请人">{{ viewCustomer.username }}</el-descriptions-item>
					<el-descriptions-item label="审核人"
						v-if="viewCustomer.approverName">{{ viewCustomer.approverName }}</el-descriptions-item>
					<el-descriptions-item label="审核时间"
						v-if="viewCustomer.approveTime">{{ formatDateTime(viewCustomer.approveTime) }}</el-descriptions-item>
					<el-descriptions-item label="客户介绍" :span="2">{{ viewCustomer.intro }}</el-descriptions-item>
					<!-- <el-descriptions-item label="申请原因" :span="2">{{ viewCustomer.applyReason }}</el-descriptions-item> -->
					<!-- <el-descriptions-item label="审核意见" :span="2" v-if="viewCustomer.approveRemark">{{ viewCustomer.approveRemark }}</el-descriptions-item> -->
				</el-descriptions>

				<el-divider content-position="left">联系人信息</el-divider>
				<el-table :data="viewCustomer.customerContacts" style="width: 100%" stripe
					v-if="viewCustomer.customerContacts && viewCustomer.customerContacts.length">
					<el-table-column prop="name" label="姓名"></el-table-column>
					<el-table-column prop="mobile" label="手机号码">
						<template #default="{ row }">
							{{ (userId == viewCustomer.userId || isBoss == 1) ? row.mobile : maskPhone(row.mobile) }}
						</template>
					</el-table-column>
					<el-table-column prop="email" label="电子邮箱"></el-table-column>
					<el-table-column prop="position" label="职位"></el-table-column>
					<el-table-column prop="intro" label="职位介绍"></el-table-column>
				</el-table>
			</el-card>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		getCustomersInfo,
		getCustomerListSta,
		addCustomerSta,
		updateCustomerSta,
		customersApproval
	} from '@/api/customer'

	import dayjs from 'dayjs'

	export default {
		name: 'CustomerApproval',
		computed: {
			...mapState({
				username: state => state.user.username,
				userId: state => state.user.id,
				isBoss: state => state.user.isBoss,
				role: state => state.user.role
			}),
			mainFields() {
				return [{
						key: 'customerName',
						label: '客户名称'
					},
					{
						key: 'industry',
						label: '所属行业'
					},
					{
						key: 'creditRating',
						label: '信用评级'
					},
					{
						key: 'intro',
						label: '客户介绍'
					},
					{
						key: 'applyReason',
						label: '申请原因'
					}
				];
			},
			mainChangeMap() {
				if (!this.currentApproval || !this.currentApproval.lastData) return {};
				const changes = this.getCustomerChanges(this.currentApproval, this.currentApproval.lastData);
				const map = {};
				this.mainFields.forEach(f => {
					const found = changes.find(c => c.label === f.label);
					if (found) {
						map[f.key] = {
							before: found.before,
							after: found.after,
							label: f.label
						};
					}
				});
				return map;
			},
			mainChangedFields() {
				// 只返回有变更的主字段
				return this.mainFields.filter(f => this.mainChangeMap[f.key]);
			},
			contactChanges() {
				if (!this.currentApproval || !this.currentApproval.lastData) return [];
				return this.getContactFieldDiff(
					this.currentApproval.customerContacts,
					this.currentApproval.lastData.customerContacts
				);
			},
			detailedChanges() {
				if (!this.currentApproval || !this.currentApproval.lastData) return [];
				const changes = this.getCustomerChanges(this.currentApproval, this.currentApproval.lastData);
				const mainFields = [{
						key: 'customerName',
						label: '客户名称'
					},
					{
						key: 'industry',
						label: '所属行业'
					},
					{
						key: 'creditRating',
						label: '信用评级'
					},
					{
						key: 'intro',
						label: '客户介绍'
					},
					{
						key: 'applyReason',
						label: '申请原因'
					}
				];
				const result = [];
				mainFields.forEach(f => {
					const found = changes.find(c => c.label === f.label);
					if (found) {
						result.push({
							field: f.label,
							before: found.before,
							after: found.after
						});
					}
				});
				// 联系人
				changes.forEach(c => {
					if (c.type === 'contact') {
						result.push({
							name: c.name,
							field: c.field,
							before: c.before,
							after: c.after
						});
					}
				});
				return result || [];
			},
			mainChanges() {
				if (!this.currentApproval || !this.currentApproval.lastData) return [];
				const fields = [{
						key: 'customerName',
						label: '客户名称'
					},
					{
						key: 'industry',
						label: '所属行业'
					},
					{
						key: 'creditRating',
						label: '信用评级'
					},
					{
						key: 'intro',
						label: '客户介绍'
					},
					{
						key: 'applyReason',
						label: '申请原因'
					}
				];
				const result = [];
				fields.forEach(f => {
					const before = this.currentApproval.lastData[f.key];
					const after = this.currentApproval[f.key];
					if ((before || '-') !== (after || '-')) {
						result.push({
							field: f.label,
							before: before || '-',
							after: after || '-'
						});
					}
				});
				return result;
			},
			allChanges() {
				if (!this.currentApproval || !this.currentApproval.lastData) return [];
				const result = [];
				// 主信息变更
				const mainFields = [{
						key: 'customerName',
						label: '客户名称'
					},
					{
						key: 'industry',
						label: '所属行业'
					},
					{
						key: 'creditRating',
						label: '信用评级'
					},
					{
						key: 'intro',
						label: '客户介绍'
					},
					{
						key: 'applyReason',
						label: '申请原因'
					}
				];
				mainFields.forEach(f => {
					const before = this.currentApproval.lastData[f.key];
					const after = this.currentApproval[f.key];
					if ((before || '-') !== (after || '-')) {
						result.push({
							object: '客户主信息',
							field: f.label,
							before: before || '-',
							after: after || '-'
						});
					}
				});
				// 联系人变更
				const lastContacts = this.currentApproval.lastData.customerContacts || [];
				const currentContacts = this.currentApproval.customerContacts || [];
				const lastMap = new Map((lastContacts).map(c => [c.id || c.mobile || c.email || c.name, c]));
				const currMap = new Map((currentContacts).map(c => [c.id || c.mobile || c.email || c.name, c]));
				const fields = ['name', 'mobile', 'email', 'position', 'intro'];
				// 新增和修改
				(currentContacts).forEach(curr => {
					const key = curr.id || curr.mobile || curr.email || curr.name;
					const prev = lastMap.get(key);
					if (!prev) {
						fields.forEach(field => {
							result.push({
								//object: curr.name || '-',
								object: '联系人信息',
								field: this.getContactFieldLabel(field),
								before: '-',
								after: curr[field] || '-'
							});
						});
					} else {
						fields.forEach(field => {
							if ((curr[field] || '-') !== (prev[field] || '-')) {
								result.push({
									//object: curr.name || '-',
									object: '联系人信息',
									field: this.getContactFieldLabel(field),
									before: prev[field] || '-',
									after: curr[field] || '-'
								});
							}
						});
					}
				});
				// 删除
				(lastContacts).forEach(prev => {
					const key = prev.id || prev.mobile || prev.email || prev.name;
					if (!currMap.has(key)) {
						fields.forEach(field => {
							result.push({
								//object: prev.name || '-',
								object: '联系人信息',
								field: this.getContactFieldLabel(field),
								before: prev[field] || '-',
								after: '-'
							});
						});
					}
				});
				console.log('result', result)
				const newdata = this.mergeData(result)
				return newdata;
			}
		},
		data() {
			return {
				loading: false,
				filterForm: {
					customerName: '',
					status: '',
					type: ''
				},
				approvalList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				approveDialogVisible: false,
				viewDialogVisible: false,
				dialogTitle: '新建客户审核',
				viewCustomer: {},
				currentApproval: null,
				customerForm: {
					customerName: '',
					industry: '',
					creditRating: 3,
					intro: '',
					applyReason: '',
					customerContacts: []
				},
				approveForm: {
					status: '1',
					approveRemark: ''
				},
				rules: {
					customerName: [{
						required: true,
						message: '请输入客户名称',
						trigger: 'blur'
					}],
					industry: [{
						required: true,
						message: '请输入所属行业',
						trigger: 'blur'
					}],
					intro: [{
						required: true,
						message: '请输入客户介绍',
						trigger: 'blur'
					}],
					creditRating: [{
						required: true,
						message: '请选择信用评级',
						trigger: 'change'
					}],
					applyReason: [{
						required: true,
						message: '请输入申请原因',
						trigger: 'blur'
					}]
				},
				approveRules: {
					status: [{
						required: true,
						message: '请选择审核结果',
						trigger: 'change'
					}]
				}
			}
		},
		created() {
			this.fetchData()
		},
		methods: {
			mergeData(data) {
				const merged = {};

				// 遍历原始数据
				data.forEach(item => {
					const key = `${item.object}-${item.field}`;

					// 如果还没有这个键，初始化
					if (!merged[key]) {
						merged[key] = {
							object: item.object,
							field: item.field,
							before: item.before,
							after: item.after
						};
					} else {
						// 合并规则：
						// 1. 如果当前记录的before不是'-'，则更新before
						// 2. 如果当前记录的after不是'-'，则更新after
						if (item.before !== '-') {
							merged[key].before = item.before;
						}
						if (item.after !== '-') {
							merged[key].after = item.after;
						}
					}
				});

				// 转换为数组并过滤掉完全无效的记录
				return Object.values(merged).filter(item =>
					item.before !== '-' || item.after !== '-'
				);
			},

			async handleCopy(row) {
				this.customerForm = {
					...row,
					customerContacts: row.customerContacts ? [...row.customerContacts] : [{
						name: '',
						mobile: '',
						email: '',
						position: '',
						intro: ''
					}]
				}
				await navigator.clipboard.writeText(JSON.stringify(this.customerForm));
				this.$message.success('复制成功')
			},
			canApprove(row) {
				return this.isBoss === 1 || row.applicantId !== this.userId
			},
			canEdit(row) {
				return row.applicantId === this.userId && row.status === 'pending'
			},
			getStatusType(status) {
				const statusMap = {
					0: 'warning',
					1: 'success',
					2: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '待审核',
					1: '已通过',
					2: '已拒绝'
				}
				return statusMap[status] || '未知'
			},
			maskPhone(phone) {
				if (!phone) return ''
				return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
			},
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			async fetchData() {
				try {
					this.loading = true
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						businessType: 'customer',
						...this.filterForm
					}

					const res = await getCustomerListSta(params)
					this.approvalList = res.data.records || []
					this.total = res.data.total || 0
				} catch (error) {
					console.error('获取审核列表失败:', error)
					this.$message.error('获取数据失败')
				} finally {
					this.loading = false
				}
			},
			handleQuery() {
				this.handleSearch()
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					customerName: '',
					status: '',
					type: ''
				}
				this.currentApproval = null
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			handleAddCustomer() {
				this.dialogTitle = '新建客户审核'
				this.customerForm = {
					customerName: '',
					industry: '',
					creditRating: 3,
					intro: '',
					applyReason: '',
					customerContacts: [{
						name: '',
						mobile: '',
						email: '',
						position: '',
						intro: ''
					}]
				}
				this.currentApproval = null
				this.dialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑客户审核'
				this.customerForm = {
					...row,
					// applyReason: row.applyReason,
					customerContacts: row.customerContacts ? [...row.customerContacts] : [{
						name: '',
						mobile: '',
						email: '',
						position: '',
						intro: ''
					}]
				}
				this.currentApproval = row
				this.dialogVisible = true
			},
			async handleApprove(row) {
				let a = await getCustomersInfo({
					uuid: row.uuid
				})
				row.lastData = a.data;
				console.log(row.lastData);

				// 如果没有 lastData，自动生成一个空的 lastData
				if (!row.lastData) {
					row.lastData = {
						customerName: '',
						industry: '',
						creditRating: '',
						intro: '',
						applyReason: '',
						customerContacts: (row.customerContacts || []).map(() => ({
							name: '',
							mobile: '',
							email: '',
							position: '',
							intro: ''
						}))
					};
				}
				this.currentApproval = row;
				this.approveForm = {
					status: '1',
					approveRemark: ''
				}
				this.approveDialogVisible = true;
			},
			handleView(row) {
				this.viewCustomer = {
					...row,
					applyTime: row.applyTime ? this.formatDateTime(row.applyTime) : '',
					approveTime: row.approveTime ? this.formatDateTime(row.approveTime) : ''
				}
				this.viewDialogVisible = true
			},
			async submitForm() {
				try {
					await this.$refs.customerForm.validate()

					const formData = {
						...this.customerForm,
						businessType: 'customer',
						type: this.currentApproval ? 'edit' : 'add',
						applicantId: this.userId,
						applicantName: this.username
					}

					if (this.currentApproval) {
						// 更新审核申请
						formData.id = this.currentApproval.id
						await updateCustomerSta(formData)
					} else {
						// 创建新的审核申请
						await addCustomerSta(formData)
					}

					this.$message.success('提交成功')
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('提交表单失败:', error)
					this.$message.error('提交失败')
				}
			},
			async submitApprove() {
				try {
					await this.$refs.approveForm.validate()
					this.currentApproval.status = this.approveForm.status;
					const approveData = this.currentApproval;
					// const approveData = {
					// 	id: this.currentApproval.id,
					// 	status: this.approveForm.status,
					// 	approveRemark: this.approveForm.approveRemark,
					// 	// approverId: this.userId,
					// 	// approverName: this.username,
					// 	// approveTime: new Date().toISOString()
					// }

					await customersApproval(approveData)
					this.$message.success('审核完成')
					this.approveDialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('审核失败:', error)
					this.$message.error('审核失败')
				}
			},
			addContact() {
				if (this.customerForm.customerContacts.length >= 5) {
					this.$message.warning('最多只能添加5个联系人')
					return
				}
				this.customerForm.customerContacts.push({
					name: '',
					mobile: '',
					email: '',
					position: '',
					intro: ''
				})
			},
			removeContact(index) {
				this.customerForm.customerContacts.splice(index, 1)
			},
			getContactFieldLabel(field) {
				const map = {
					name: '姓名',
					mobile: '手机号码',
					email: '邮箱',
					position: '职位',
					intro: '职位介绍'
				};
				return map[field] || field;
			}
		},
		watch: {
			dialogVisible(val) {
				if (!val) {
					this.$refs.customerForm && this.$refs.customerForm.resetFields && this.$refs.customerForm.resetFields()
				}
			},
			approveDialogVisible(val) {
				if (!val) {
					this.$refs.approveForm && this.$refs.approveForm.resetFields && this.$refs.approveForm.resetFields()
				}
			},
			viewDialogVisible(val) {
				if (!val) {
					this.viewCustomer = {}
				}
			}
		}
	}
</script>

<style scoped>
	.contact-info {
		margin-top: 20px;
	}

	.contact-info h3 {
		margin-bottom: 15px;
		font-size: 16px;
		color: #303133;
	}

	.contacts-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}

	.contacts-header h3 {
		margin: 0;
		font-size: 16px;
		color: #303133;
	}

	.contact-item {
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		padding: 10px 0;
		margin-bottom: 12px;
		background-color: #fafafa;
	}

	.contact-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}

	.contact-header h4 {
		margin: 0;
		font-size: 14px;
		color: #606266;
	}

	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.compare-title {
		font-weight: bold;
		font-size: 16px;
		margin-bottom: 8px;
	}

	.compare-label {
		font-weight: bold;
		color: #606266;
		margin-bottom: 4px;
	}

	.compare-item {
		margin-bottom: 4px;
	}

	.compare-field {
		color: #909399;
	}

	.compare-value-old {
		color: #909399;
	}

	.compare-value-new {
		color: #409EFF;
		font-weight: bold;
	}

	.contact-compare-header {
		margin-bottom: 4px;
	}

	.contact-group-even {
		background: #f7faff;
	}

	.contact-group-odd {
		background: #fff;
	}
</style>